import React, { useState } from "react";
import Map, { Marker } from "react-map-gl";
import { Box, Typography } from "@mui/material";

const MapComponent = ({ sensorData }) => {
  const [viewState, setViewState] = useState({
    latitude: sensorData[0]?.data.latitude || 37.7749, // Default to the first sensor or a fallback
    longitude: sensorData[0]?.data.longitude || -122.4194,
    zoom: 12,
  });

  return (
    <Box sx={{ height: "500px", width: "100%" }}>
      <Typography variant="h6" gutterBottom>
        Sensor Data Map
      </Typography>
      <Map
        {...viewState}
        onMove={(evt) => setViewState(evt.viewState)}
        mapStyle="mapbox://styles/mapbox/streets-v11"
        mapboxAccessToken={process.env.REACT_APP_MAPBOX_ACCESS_TOKEN} // Make sure to set this in your .env file
      >
        {sensorData.map((sensor) => (
          <Marker
            key={sensor._id}
            latitude={sensor.data.latitude}
            longitude={sensor.data.longitude}
          >
            <Box
              sx={{
                background: "#1976d2",
                color: "#fff",
                padding: "5px",
                borderRadius: "5px",
              }}
            >
              Alt: {sensor.data.altitude}m
            </Box>
          </Marker>
        ))}
      </Map>
    </Box>
  );
};

export default MapComponent;
